import angular from 'angular';
import _ from 'lodash';

(function() {
    'use strict';
    angular.module('app.core').factory('RegistrationSchemesDA', RegistrationSchemesDA);

    RegistrationSchemesDA.$inject = ['CONF', 'Restangular', 'RegistrationScheme'];

    /* @ngInject */
    function RegistrationSchemesDA(CONF, Restangular, RegistrationScheme) {
        var baseUrl = CONF.apiBaseUrl + '/v1' + '/registration-scheme';

        var exports = {
            getByCountry: getByCountry
        };

        return exports;

        ////////////////
        function getByCountry(countryCode) {
            return Restangular.oneUrl(baseUrl)
                .all('country')
                .all(countryCode)
                .getList()
                .then(function(regSchemes) {
                    return _.map(regSchemes, function(rS) {
                        return new RegistrationScheme(rS);
                    });
                });
        }
    }
})();
